import React from 'react'
import { Instagram, Linkedin, Youtube } from 'lucide-react'

const Footer: React.FC = () => {
  const socialLinks = [
    {
      name: 'Instagram',
      icon: Instagram,
      url: 'https://www.instagram.com/excelnerds'
    },
    {
      name: 'LinkedIn',
      icon: Linkedin,
      url: 'https://www.linkedin.com/company/excelnerds'
    },
    {
      name: 'YouTube',
      icon: Youtube,
      url: 'https://www.youtube.com/@excelnerds'
    }
  ]

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto text-center">
          {/* Welcome Text */}
          <div className="mb-8">
            <p className="text-lg leading-relaxed text-gray-300">
              Welcome to ExcelNerds.com! Whether you're just starting or looking to sharpen advanced skills, our goal is to make Excel accessible, efficient, and even fun. Through clear tutorials, practical tips, and in-depth guides, we break down complex concepts into simple, actionable steps. Dive in, explore, and let's start transforming the way you work with Excel!
            </p>
          </div>

          {/* Social Media Links */}
          <div className="flex justify-center space-x-6 mb-8">
            {socialLinks.map((social) => {
              const Icon = social.icon
              return (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center w-12 h-12 bg-excel-green hover:bg-excel-green/80 rounded-full transition-colors duration-300"
                  aria-label={social.name}
                >
                  <Icon className="h-6 w-6 text-white" />
                </a>
              )
            })}
          </div>

          {/* Copyright */}
          <div className="border-t border-gray-800 pt-8">
            <p className="text-gray-400">
              © {new Date().getFullYear()} ExcelNerds.com. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer